import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import CareersHeroSection from './components/CareersHeroSection/CareersHeroSection.component'
import CareersVideoSection from './components/CareersVideoSection/CareersVideoSection.component'
import CareersWhyChooseUSABG from './components/CareersWhyChooseUSABG/CareersWhyChooseUSABG.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './Careers.page.scss'

class CareersPage extends React.Component {
  componentDidMount() {
    document.title = 'Careers | Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='CareersPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <CareersHeroSection />
        <CareersVideoSection />
        <CareersWhyChooseUSABG />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default CareersPage
